import { CustomerDetails } from "../../../models/customers/customerDetails";
import { CompletePayRequest } from "../../../models/paymentProcess/completePayRequest";
import CompletePayRequestProviderData from "../../../models/paymentProcess/completePayRequestProviderData";
import { CompletePayResult } from "../../../models/paymentProcess/completePayResult";
import CompletePayResultProviderData from "../../../models/paymentProcess/completePayResultProviderData";
import { IntentToPayTypeRequest } from "../../../models/paymentProcess/intentToPayRequest";
import IntentToPayRequestProviderData from "../../../models/paymentProcess/intentToPayRequestProviderData";
import { IntentToPayResult } from "../../../models/paymentProcess/intentToPayResult";
import { PaymentChargeType } from "../../../models/paymentProcess/payment-charge-type";
import { PaymentIntentItem } from "../../../models/paymentProcess/payment-intent-item";
import { UpdateIntentToPayRequest } from "../../../models/paymentProcess/updateIntentToPayRequest";
import { PaymentMethodType } from "../../../models/paymentProviders/paymentMethodType";

export interface IntentToPayRegisterEventData<TProviderDataRequest> {
  PaymentProviderId: string;
  PaymentProviderName?: string;
  PaymentMethodType: PaymentMethodType;
  CustomerDetails: CustomerDetails;
  PaymentIntentItems: PaymentIntentItem[];
  PaymentProviderData?: TProviderDataRequest;
  PaymentChargeType: PaymentChargeType;
  StoredPaymentMethodId?: string;
}

export const mapIntentToPayRegisterEventData = <TProviderDataRequest extends IntentToPayRequestProviderData>(
  request: IntentToPayTypeRequest<TProviderDataRequest>
): IntentToPayRegisterEventData<TProviderDataRequest> =>
  ({
    PaymentProviderId: request.paymentProviderConfigurationId,
    PaymentProviderName: request.providerData?.providerName,
    PaymentMethodType: request.paymentMethodType,
    CustomerDetails: request.customerDetails,
    PaymentIntentItems: request.paymentIntentItems,
    PaymentProviderData: request.providerData,
    PaymentChargeType: request.paymentChargeType,
    StoredPaymentMethodId: request.storedPaymentMethodId,
  } as IntentToPayRegisterEventData<TProviderDataRequest>);

export interface IntentToPayResultEventData {
  ResultId: string;
  ResultError?: string;
  PaymentProviderId: string;
  PaymentProviderName?: string;
  PaymentMethodType: PaymentMethodType;
  CustomerTransactionId: string;
  SuccessfulRegistation: boolean;
  PaymentProviderData?: IntentToPayRequestProviderData;
}

export const mapIntentToPayResultEventData = (result: IntentToPayResult): IntentToPayResultEventData =>
  ({
    ResultId: result.id,
    ResultError: result.errorMessage,
    PaymentProviderId: result.paymentProviderConfigurationId,
    PaymentProviderName: result.providerData?.providerName,
    PaymentMethodType: result.paymentMethodType,
    CustomerTransactionId: result.customerTransactionId,
    SuccessfulRegistation: result.success,
    PaymentProviderData: result.providerData,
    PaymentNextJourney: result.nextPaymentJourney,
  } as IntentToPayResultEventData);

// Update payment event data

export interface UpdatePaymentEventData {
  PaymentProviderId: string;
  PaymentProviderName?: string;
  PaymentProviderData?: IntentToPayRequestProviderData;
}

export const mapUpdatePaymentEventData = (request: UpdateIntentToPayRequest): UpdatePaymentEventData =>
  ({
    PaymentProviderId: request.paymentProviderConfigurationId,
    PaymentProviderName: request.providerData?.providerName,
    PaymentProviderData: request.providerData,
  } as UpdatePaymentEventData);

// Cancel payment event data

export interface CancelPaymentEventData {
  CustomerTransactionId: string;
}

// Complete payment event data

export interface CompletePaymentRequestEventData {
  PaymentProviderName?: string;

  StoredPaymentMethodId?: string;
  StorePaymentMethod?: boolean;

  PaymentChargeType: PaymentChargeType;
  PaymentProviderData?: CompletePayRequestProviderData;
}

export const mapCompletePaymentEventData = (request: CompletePayRequest): CompletePaymentRequestEventData =>
  ({
    PaymentProviderName: request.providerData?.providerName,
    StoredPaymentMethodId: request.storedPaymentMethodId,
    StorePaymentMethod: request.storePaymentMethod,
    PaymentChargeType: request.paymentChargeType,
    PaymentProviderData: request.providerData,
  } as CompletePaymentRequestEventData);

export interface CompletePaymentResultEventData {
  ResultId: string;
  ResultError?: string;
  PaymentProviderId: string;
  PaymentProviderName?: string;
  CustomerTransactionId: string;
  SuccessfulRegistation: boolean;
  PaymentProviderData?: CompletePayResultProviderData;
}

export const mapCompletePaymentResultEventData = (result: CompletePayResult): CompletePaymentResultEventData =>
  ({
    ResultId: result.id,
    ResultError: result.errorMessage,
    PaymentProviderId: result.paymentProviderConfigurationId,
    PaymentProviderName: result.providerData?.providerName,
    CustomerTransactionId: result.customerTransactionId,
    SuccessfulRegistation: result.success,
    PaymentProviderData: result.providerData,
  } as CompletePaymentResultEventData);
